import { FC } from "react";

import { ORGANIZATION_ASSISTANT_CONFIG } from "./helpers/organizationAssistantConfig";
import { ORGANIZATION_CHAT_ADAPTER } from "./helpers/organizationChatAdapter";

import { ConnectedChat } from "@/features/Assistant/Chat/ConnectedChat";
import { useAssistantWidget } from "@/features/Assistant/Widget/helpers/useAssistantWidget";
import { AssistantWidgetEvents } from "@/features/Assistant/Widget/helpers/useLogAssistantWidgetEvents";
import { Widget } from "@/features/Assistant/Widget/Widget";

interface OrganizationAssistantWidgetProps extends AssistantWidgetEvents {
  hidden: boolean;
}

export const OrganizationAssistantWidget: FC<OrganizationAssistantWidgetProps> = ({
  hidden,
  onOpen,
  onClose,
  onMessageSent,
  onConversationRestarted,
  onToolRendered,
}) => {
  const widget = useAssistantWidget({ onOpen, onClose, onConversationRestarted });
  return (
    <Widget feature={ORGANIZATION_ASSISTANT_CONFIG.feature} widget={widget} hidden={hidden}>
      <ConnectedChat
        adapter={ORGANIZATION_CHAT_ADAPTER}
        onControlsChange={widget.setControls}
        onMessageSent={onMessageSent}
        onToolRendered={onToolRendered}
      />
    </Widget>
  );
};
